/* eslint-disable no-useless-escape */
'use strict';

var baseCart = require('base/cart/cart');
var storeLocatorModal = require('../storeLocator/storeLocatorModal');

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
	var newUrl = url;
	newUrl +=
		(newUrl.indexOf('?') !== -1 ? '&' : '?') +
		Object.keys(params).map(function (key) { return key + '=' + encodeURIComponent(params[key]); }).join('&');

	return newUrl;
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
	if (data.valid.error) {
		if (data.valid.message) {
			var errorHtml =
				'<div class="alert alert-danger alert-dismissible valid-cart-error ' +
				'fade show" role="alert">' +
				'<button type="button" class="close" data-bs-dismiss="alert" aria-label="Close">' +
				'<span aria-hidden="true">&times;</span>' +
				'</button>' +
				data.valid.message +
				'</div>';

			$('.cart-error').append(errorHtml);
		} else {
			$('.cart').empty();
			$('.cart-empty').removeClass('d-none').addClass('d-block');
			$('.number-of-items').empty().append(data.resources.numberOfItems);
			$('.breadcrumb-item a:contains("Cart")').text('Cart');
			$('.minicart-quantity').empty().append(data.numItems);
			$('.minicart-link').attr({
				'aria-label': data.resources.minicartCountOfItems,
				title: data.resources.minicartCountOfItems,
			});
			$('.minicart .popover').empty();
			$('.minicart .popover').removeClass('show');
		}
	}
}

/**
 * Prepare a sanitized input for the listName parameter
 * Pass the field to be sanitized
 *
 * @return {array} - sanitized string
 */
function sanitizeFieldInput(inputString) {
	if(inputString){
		var outputString = '';

		outputString = inputString.replace(/<script[^>]*?>.*?<\/script>/gi, '').replace(/<[\/\!]*?[^<>]*?>/gi, '').
			replace(/<style[^>]*?>.*?<\/style>/gi, '').
			replace(/<![\s\S]*?--[ \t\n\r]*>/gi, '').
			replace(/&nbsp;/g, '');

		return outputString;

	}
}

/**
 * Prepare an array of objects of products being added to cart
 * pid as key and listName as value
 *
 * @return {array} - array of reduced object data for analytics
 */
function getAnalyticsProductListData(item, isCYO) {
	var listArray = [];
	if (item) {
		//ID is Variant id for CYO Products and For normal product refer Variant for Variant ID
		listArray = (isCYO) ? item.map(({ variant, list, productRating }) => ({ 'pid': variant, 'listName': sanitizeFieldInput(list), 'productRating': productRating })) : item.map(({ variant, list, productRating }) => ({ 'pid': variant, 'listName': sanitizeFieldInput(list), 'productRating': productRating }));
	}
	return encodeURIComponent(JSON.stringify(listArray));
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
	$('body').trigger('cart:updateProratedMessage', data);
	$('.number-of-items').empty().append(data.resources.numberOfItems);
	$('.breadcrumb-item a:contains("Cart")').text(`Cart (${data.numItems})`);
	$('.shipping-cost').empty().append('-');
	$('.tax-total').empty().append('-');
	$('.grand-total').empty().append(data.totals.grandTotalNet);
	//order discount shown if value is not zero.
	if (data.totals.orderLevelDiscountTotal.value > 0 && !data.totals.isBonusDiscountApplied) {
		$('.order-discount-row').removeClass('d-none');
		$('.order-discount-total').empty().append('- '+data.totals.orderLevelDiscountTotal.formatted);
	} else {
		$('.order-discount-row').addClass('d-none');
	}
	//Promo amount shown if value is not zero.
	if (data.totals.promoAppliedAmount.value > 0) {
		$('.promo-row').removeClass('d-none');
		$('.promo-total-applied-amount').empty().append('- '+data.totals.promoAppliedAmount.formatted);
	} else {
		$('.promo-row').addClass('d-none');
	}
	
	
	$('.sub-total').empty().append(data.totals.subTotalCharm);
	//prorated discount shown if value is not zero.
	if (data.totals.discountedPriceTotal.value > 0) {
		$('.prorated-price-main').removeClass('d-none');
		$('.proratedDiscount-total').empty().append('-'+data.totals.discountedPriceTotal.formatted);
	} else {
		$('.prorated-price-main').addClass('d-none');
	}
	$('.minicart-quantity').empty().append(data.numItems);
	$('.minicart-link').attr({
		'aria-label': data.resources.minicartCountOfItems,
		title: data.resources.minicartCountOfItems,
	});
	if (data.klarnaTotal > 0 && data.isKlarnaEligible) {
		$('.cartKlarna').empty().append(data.klarnaTotalHtml);
		window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
		window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
	} else if (!data.isKlarnaEligible) {
		$('.cartKlarna').empty();
	}
	if (data.totals.orderLevelDiscountTotal.value > 0 && !data.totals.isBonusDiscountApplied) {
		$('.order-discount').removeClass('hide-order-discount');
		$('.order-discount-total')
			.empty()
			.append('- ' + data.totals.orderLevelDiscountTotal.formatted);
	} else {
		$('.order-discount').addClass('hide-order-discount');
	}

	if (data.totals.shippingLevelDiscountTotal.value > 0) {
		$('.shipping-discount').removeClass('hide-shipping-discount');
		$('.shipping-discount-total')
			.empty()
			.append('- ' + data.totals.shippingLevelDiscountTotal.formatted);
	} else {
		$('.shipping-discount').addClass('hide-shipping-discount');
	}

	data.items.forEach(function (item) {
		if (data.totals.orderLevelDiscountTotal.value > 0) {
			$('.coupons-and-promos').empty().append(data.totals.discountsHtml);
		}
		if (item.renderedPromotions && !item.customProratedPrice) {
			$('.item-' + item.UUID)
				.empty()
				.append(item.renderedPromotions);
		} else {
			$('.item-' + item.UUID).empty();
		}
		$('.uuid-' + item.UUID + ' .unit-price')
			.empty()
			.append(item.renderedPrice);
		$('.line-item-price-' + item.UUID + ' .unit-price')
			.empty()
			.append(item.renderedPrice);
		$('.item-total-' + item.UUID).find('.proratedPrice').html(item.customProratedPrice);
		
		// holder items with attached charms have different pricing rules
		if (item.hasAttached) {
			$('.item-total-' + item.UUID)
				.find('.line-item-total-price-amount')
				.html(item.engravingTotalPrice);
			if (item.cyoTotalProratedDiscount!='') {
				var customProratedMessage = '-'+item.cyoTotalProratedDiscount+ ' ' +item.proratedCalloutMsg;
				$('.item-total-' + item.UUID).find('.cyoProrated').html(customProratedMessage);
			}
			else{
				$('.item-total-' + item.UUID).find('.cyoProrated').html('');
			}
				
				
		} else {
			$('.item-total-' + item.UUID)
				.empty()
				.append(item.priceTotal.renderedPrice);
			if (item.customProratedPrice!=='') {
				// eslint-disable-next-line no-redeclare
				var customProratedMessage = '-'+item.customProratedPrice + ' ' +item.proratedCalloutMsg;
				$('.item-total-' + item.UUID).find('.proratedPrice').html(customProratedMessage);
			}
			else{
				$('.item-total-' + item.UUID).find('.proratedPrice').html('');
			}
				
		}
	});
}

function updateBonusItemTemplate(template){
	if(template){
		$('.bonus-product-list').remove();
		$('.cart-page-left-section .card.product-info:last').after(template);
	}
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
	var errorHtml =
		'<div class="alert alert-danger alert-dismissible valid-cart-error ' +
		'fade show" role="alert">' +
		'<button type="button" class="close" data-bs-dismiss="alert" aria-label="Close">' +
		'<span aria-hidden="true">&times;</span>' +
		'</button>' +
		message +
		'</div>';

	$('.cart-error').append(errorHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
	var html = '';
	$('.approaching-discounts').empty();
	if (approachingDiscounts.length > 0) {
		approachingDiscounts.forEach(function (item) {
			html +=
				'<div class="single-approaching-discount text-center">' +
				item.discountMsg +
				'</div>';
		});
	}
	$('.approaching-discounts').append(html);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
	var lineItem;
	var messages = '';

	for (var i = 0; i < data.items.length; i++) {
		if (data.items[i].UUID === uuid) {
			lineItem = data.items[i];
			break;
		}
	}

	if (lineItem != null) {
		$('.availability-' + lineItem.UUID).empty();
 
		if(data.inventoryMessageJson.length > 0){
			var storeLineItem = data.inventoryMessageJson.filter(function(item){
				return item.key === uuid;
			});
			if(storeLineItem.length > 0){
				messages +='<p class="line-item-attributes '+storeLineItem[0].value.availabilityStatusClass+'">' + storeLineItem[0].value.displayMessage + '</p>';
			}
			$('.quantity[data-uuid="' + uuid + '"]').val(lineItem.quantity);
			$('.quantity[data-uuid="' + uuid + '"]').siblings('.quantity.custom-select').find('.current').text(lineItem.quantity);
			
		}else{
			if (lineItem.availability) {
				if (lineItem.availability.messages) {
					lineItem.availability.messages.forEach(function (message) {
						messages +=
							'<p class="line-item-attributes">' + message + '</p>';
					});
				}

				if (lineItem.availability.inStockDate) {
					messages +=
						'<p class="line-item-attributes line-item-instock-date">' +
						lineItem.availability.inStockDate +
						'</p>';
				}
			}
		}

		$('.availability-' + lineItem.UUID).html(messages);
	}
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, productName, uuid, gtmProductData,actionSource) {
	var $deleteConfirmBtn = $('.cart-remove-confirmation-btn');
	var $productToRemoveSpan = $('.product-to-remove');

	$deleteConfirmBtn.data('pid', productID);
	$deleteConfirmBtn.data('action', actionUrl);
	$deleteConfirmBtn.data('uuid', uuid);
	$deleteConfirmBtn.data('gtmProductData', gtmProductData);
	$deleteConfirmBtn.data('actionSource', actionSource);

	$productToRemoveSpan.empty().append(productName);
}

function showHideInventoryMessage(event, msg, data) {
	event.preventDefault();
	var inventoryMessageWrapper = $('.cart-error-messaging.cart-error');
	$('.cart-error-messaging.cart-error').empty();

	if (event === false) {
		createErrorNotification(data.basket.valid.message);
	} else {
		createErrorNotification(msg);
	}

	inventoryMessageWrapper.fadeIn();

	setTimeout(function () {
		inventoryMessageWrapper.fadeOut();
	}, 3000);

	return false;
}

/**
 * hides or show attach button based on 
 */
function updateCYOAttachButton(data) {
	data.items.forEach(function (item) {
		if (item.attachableCharmsInCart && item.attachableCharmsInCart.length === 0) {
			let attachButton = $('.uuid-' + item.UUID).find('.cyo-attach-wrapper');
			attachButton.addClass('d-none');
		}
	});
}

var exportCart = $.extend({}, baseCart, {
	cartBaseExtend: function () {
		$('body').on('click', '.cart-remove-confirmation-btn', function (e) {
			e.preventDefault();

			var productID = $(this).data('pid');
			var url = $(this).data('action');
			var uuid = $(this).data('uuid');
			var gtmProductData = $(this).data('gtmProductData');
			var actionSource = $(this).data('actionSource');
			var urlParams = {
				pid: productID,
				uuid: uuid,
			};

			url = appendToUrl(url, urlParams);

			$('body > .modal-backdrop').remove();

			$.spinner().start();

			$('body').trigger('cart:beforeUpdate');

			$.ajax({
				url: url,
				type: 'get',
				dataType: 'json',
				success: function (data) {
					if (data.basket.items.length === 0) {
						$('.cart').empty();
						$('.cart-empty')
							.removeClass('d-none')
							.addClass('d-block');
						$('.number-of-items')
							.empty()
							.append(data.basket.resources.numberOfItems);
						$('.minicart .minicart-icon')
							.addClass('minicart-icon-empty')
							.removeClass(' minicart-icon-full');
						$('.minicart-quantity').addClass('minicart-quantity-empty-contrast').removeClass(' minicart-quantity-full-contrast');
						$('.minicart-quantity')
							.empty()
							.append(data.basket.numItems);
						$('.minicart-link').attr({
							'aria-label':
								data.basket.resources.minicartCountOfItems,
							title: data.basket.resources.minicartCountOfItems,
						});
						$('.minicart .popover').empty();
						$('.minicart .popover').removeClass('show');
						$('body').removeClass('modal-open');
						$('html').removeClass('veiled');
						validateBasket(data.basket);
					} else {
						if (
							data.toBeDeletedUUIDs &&
							data.toBeDeletedUUIDs.length > 0
						) {
							for (
								var i = 0;
								i < data.toBeDeletedUUIDs.length;
								i++
							) {
								$('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
							}
						}
						$('.uuid-' + uuid).remove();
						$('.row.product-' + uuid).remove();
						$('.separator.separator-' + uuid).remove();
						if (!data.basket.hasBonusProduct) {
							$('.bonus-product').remove();
						}
						$('.coupons-and-promos')
							.empty()
							.append(data.basket.totals.discountsHtml);
						updateCartTotals(data.basket);
						updateCYOAttachButton(data.basket);
						updateApproachingDiscounts(
							data.basket.approachingDiscounts
						);
						if(data.basket.hasBonusProduct){
							if(data.basket.bonusItemsTemplate){
								updateBonusItemTemplate(data.basket.bonusItemsTemplate);
							}
						}else{
							$('.bonus-product-list').remove();
						}
						if (data.basket.isPickupShipmentEligible) {
							$('#pickup').removeAttr('disabled');
							$('.delivery-pickup-info-section').removeClass(
								'disabled'
							);
						} else {
							$('#pickup').attr('disabled');
							$('.delivery-pickup-info-section').addClass(
								'disabled'
							);
						}
						$('body').trigger(
							'setShippingMethodSelection',
							data.basket
						);
						validateBasket(data.basket);

						if (
							data.basket.valid.error == true &&
							(data.basket.valid.message !== null ||
								data.basket.valid.message !== 'null')
						) {
							var isCartStoreSelected =
								data.basket.myStore.store == null &&
									data.basket.myStore.distance == 0 ? false : true;
							if (
								isCartStoreSelected == false &&
								data.basket.shipmentType == 'instore'
							) {
								$('.checkout-continue')
									.find('.checkout-btn')
									.attr('data-store-selected', 'true');
							} else {
								$('.checkout-continue')
									.find('.checkout-btn')
									.attr('data-out-of-stock', 'true');
							}
						} else {
							$('.checkout-continue')
								.find('.checkout-btn')
								.attr('data-out-of-stock', 'false')
								.attr('data-store-selected', 'false');
						}
					}

					$('body').trigger('cart:update', data);
					var gtmData = {};
					gtmData.eventAction = 'Remove from Cart';
					gtmData.eventLabel = 'Create Your Own Set';
					if (data.isCyo) {
						$('body').trigger('cyo:removecyoset', gtmData);
					}
					if (data.gtmData && JSON.parse(data.gtmData).length && data.isCyo) {
						let gtmData = JSON.parse(data.gtmData);
						$('body').trigger('cyo:ecommerceremove', { gtmArray: gtmData });
						for (let index = 0; index < gtmData.length; index++) {
							let ele = gtmData[index];
							if (ele && ele.name) {
								let gtmEleData = {};
								gtmEleData.eventAction = 'Remove from Cart';
								gtmEleData.eventLabel = 'CYO-' + ele.name;
								$('body').trigger('cyo:removecyoset', gtmEleData);
							}
						}
					}

					$.spinner().stop();
					if ($('.cart-messages').length === 0) {
						$('body').append('<div class="cart-messages"></div>');
					}
					$('.cart-messages')
						.append(`<div class="alert cart-alert alert-success">
						<span class="tick tick-cta">&#10003;</span>
						<span class="alert-msg">${data.message}</span>
						<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close">
						</button></div>`);

					setTimeout(function () {
						$('.cart-messages').remove();
					}, 1500);
					if (!data.isCyo) {
						var analyticsParams = {};
						analyticsParams.gtmProductData = gtmProductData;
						analyticsParams.removalSource = actionSource;
						$('body').trigger('cart:removeitem', analyticsParams);
					}
					$('.minicart .popover').removeClass('show');
				},
				error: function (err) {
					if (err.responseJSON.redirectUrl) {
						window.location.href = err.responseJSON.redirectUrl;
					} else {
						createErrorNotification(err.responseJSON.errorMessage);
						$.spinner().stop();
					}
				},
			});
		});

		$('body').on('change', '.quantity-form > .quantity', function () {
			var preSelectQty = $(this).data('pre-select-qty');
			var quantity = $(this).val();
			var productID = $(this).data('pid');
			var url = $(this).data('action');
			var uuid = $(this).data('uuid');
			var masterId = $(this).parents('.item-attributes').data('pid-m');
			var productName = $(this).closest('.line-item-quantity').attr('gtm-data-product-name');
			var stlid = $(this).closest('.line-item-quantity').data('stlid');
			var productRating = $(this).attr('data-product-rating');
			var analyticsListingName = $.trim($(this).attr('data-nav-pdpinfo'));
			var productPrice = $(this).closest('.line-item-quantity').attr('gtm-total-price');
			let productCategory = $(this).closest('.line-item-quantity').attr('data-product-category');
			var variationItemEle = $(this).parents('.item-attributes').find('.cartItemVariations');
			var updatedSelectQty = Math.abs(quantity - preSelectQty);
			var gtmProductData = {
				id: masterId,
				name: productName.replaceAll('"', ''),				
				brand: 'James Avery',
				price: Number(productPrice && productPrice.replace('$', '')),
				variant: productID,
				category: productCategory,
				quantity: updatedSelectQty,
				list: (analyticsListingName) ? analyticsListingName : ''
			};
			if(stlid){
				gtmProductData['shopTheLookID'] = stlid;
			}
			if (productRating) {
				gtmProductData['productRating'] = parseFloat(productRating);
			}
			if(variationItemEle){
				var itemVariations = JSON.parse(variationItemEle.val());
				if(itemVariations){
					itemVariations.forEach(function (variant) {
						if(variant.displayName == 'Metal'){
							gtmProductData.dimension1 = variant.displayValue;
						}
						if(variant.displayName == 'Gemstone'){
							gtmProductData.dimension2 = variant.displayValue;
						}
						if(variant.displayName == 'Size'){
							gtmProductData.dimension3 = variant.displayValue;
						}
						if(variant.displayName == 'Color'){
							gtmProductData.dimension4 = variant.displayValue;
						}
					});
				}
			}

			var gtmQuantityData = {
				name: productName,
				quantity: quantity,
			};

			var urlParams = {
				pid: productID,
				quantity: quantity,
				uuid: uuid,
			};
			url = appendToUrl(url, urlParams);

			$(this).parents('.card').spinner().start();

			$('body').trigger('cart:beforeUpdate');

			$.ajax({
				url: url,
				type: 'get',
				context: this,
				dataType: 'json',
				success: function (data) {
					$('.quantity[data-uuid="' + uuid + '"]').val(quantity);
					$('.coupons-and-promos')
						.empty()
						.append(data.totals.discountsHtml);
					updateCartTotals(data);
					updateApproachingDiscounts(data.approachingDiscounts);
					updateAvailability(data, uuid);
					validateBasket(data);
					if(data.hasBonusProduct){
						if(data.bonusItemsTemplate){
							updateBonusItemTemplate(data.bonusItemsTemplate);
						}
					}else{
						$('.bonus-product-list').remove();
					}
					$(this).data('pre-select-qty', quantity);

					$('body').trigger('cart:update', data);
					$('body').trigger('cart:quantityupdate', gtmQuantityData);
					if(parseInt(updatedSelectQty) > 0){
						if(parseInt(quantity) > parseInt(preSelectQty)){
							$('body').trigger('gtmcart:quantityupdate', gtmProductData);
						}else{
							var gtmObject = {};
							gtmObject.gtmProductData = gtmProductData;
							gtmObject.removalSource = 'Cart Page';
							$('body').trigger('cart:removeitem', gtmObject);
						}
					}

					$.spinner().stop();
					if (
						$(this)
							.parents('.product-info')
							.hasClass('bonus-product-line-item') &&
						$('.cart-page').length
					) {
						location.reload();
					}
				},
				error: function (err) {
					if (err.responseJSON.redirectUrl) {
						window.location.href = err.responseJSON.redirectUrl;
					} else {
						createErrorNotification(err.responseJSON.errorMessage);
						$(this).val(parseInt(preSelectQty, 10));
						$.spinner().stop();
					}
				},
			});
		});

		$('body').on('click', '.remove-product', function (e) {
			e.preventDefault();
			var actionSource = '';
			var actionUrl = $(this).data('action');
			var productID = $(this).data('pid');
			var masterId = $(this).parents('.selected-item-wrapper').data('pid-m');
			var productName = $(this).data('name');
			var uuid = $(this).data('uuid');
			var productPrice = $(this).attr('gtm-total-price') ? $(this).attr('gtm-total-price') : '';
			var preSelectQty = '';
			var stlID = $(this).data('stlid');
			var productRating = $(this).attr('data-product-rating');
			let productCategory = $(this).attr('data-product-category');
			var analyticsListingName = $.trim($(this).attr('data-nav-pdpinfo'));
			var variationItemEle = $(this).parents('.selected-item-wrapper').find('.cartItemVariations');
			if($(this).hasClass('remove-btn')){
				actionSource = 'Mini Cart';
				preSelectQty = $(this).attr('data-pre-select-qty');
			}else{
				actionSource = 'Cart Page';
				preSelectQty = $(this).closest('.product-info').find('.quantity').data('pre-select-qty');
			}
			var gtmProductData = {		
				id: masterId,
				name: productName,
				brand: 'James Avery',
				price: Number(parseFloat(productPrice).toFixed(2)),
				variant: productID,
				category: productCategory,
				quantity: Number(preSelectQty),
				list: (analyticsListingName) ? analyticsListingName : ''
			};
			if(stlID) {
				gtmProductData['shopTheLookID'] = stlID;
			}
			if (productRating) {
				gtmProductData['productRating'] = parseFloat(productRating);
			}
			if(variationItemEle){
				var itemVariations = JSON.parse(variationItemEle.val());
				if(itemVariations){
					itemVariations.forEach(function (variant) {
						if(variant.displayName == 'Metal'){
							gtmProductData.dimension1 = variant.displayValue;
						}
						if(variant.displayName == 'Gemstone'){
							gtmProductData.dimension2 = variant.displayValue;
						}
						if(variant.displayName == 'Size'){
							gtmProductData.dimension3 = variant.displayValue;
						}
						if(variant.displayName == 'Color'){
							gtmProductData.dimension4 = variant.displayValue;
						}
					});
				}
			}
			

			confirmDelete(actionUrl, productID, productName, uuid, gtmProductData,actionSource);
		});

		$('body').on('afterRemoveFromCart', function (e, data) {
			e.preventDefault();
			confirmDelete(
				data.actionUrl,
				data.productID,
				data.productName,
				data.uuid
			);
		});

		$('body').on('click', '.cart-error-messaging .close', function (e) {
			e.preventDefault();
			$('.cart-error-messaging.cart-error').hide();
		});
		setTimeout(function () {
			$('.cart-error-messaging.cart-error').fadeOut();
		}, 3000);

		// magnifying icon on cart page for cyo and engraved products
		$('body').on('click', '#magnifying-image', function (e) {
			e.preventDefault();
			let imageUrl = $(this).data('href');
			$('#cyoEngravingImageModal').find('.modal-body').empty();
			$('#cyoEngravingImageModal').find('.modal-body').append(`<img src='${imageUrl}' />`);
			$('#cyoEngravingImageModal').modal('show');
		});

		// edit button click on cyo sets
		$('body').on('click', '.cyo-edit-button, .cyo-attach-button, .charm-edit-button', function (e) {
			e.preventDefault();
			let $this = $(this);
			let cyoEdit = false;
			let cyoCharm = false;
			if ($(this).hasClass('gtm-edit')) {
				cyoEdit = true;
			}
			if ($(this).hasClass('gtm-attach')) {
				cyoCharm = true;
			}
			let uuid = $this.data('uuid');
			let url = $this.data('href');
			let analyticsListName = $.trim($(this).data('navlist'));
			let form = {
				lineItemUUID: uuid
			};
			let pid = $this.data('pid');
			let pdpUrl = $this.data('pdp-url');
			$.ajax({
				url: url,
				method: 'POST',
				data: form,
				success: function (data) {
					let urlParams = {
						pid: pid,
						fromCart: true,
						lineItemUUID: uuid,
						navlist: analyticsListName
					};
					if (data.editCharm) {
						urlParams['engravingExperience'] = true;
					} else if (data.editCYO) {
						urlParams['cyoHolderExperience'] = true;
					}
					if (data.engravingUUID) {
						urlParams['item_id'] = data && data.engravingUUID;
					}
					if (cyoEdit) {
						$('body').trigger('cyo:cartactions', { action: 'Edit Item', label: 'CYO set' });
					}
					if (cyoCharm) {
						$('body').trigger('cyo:cartactions', { action: 'Edit Item', label: 'Attach' });
					}
					pdpUrl = appendToUrl(pdpUrl, urlParams);
					window.location.href = pdpUrl;
				}
			});
		});
	},
	create_custom_dropdowns() {
		if ($('.cart-page').length > 0) {
			$('select.quantity').each(function (i, select) {
				if (!$(this).next().hasClass('dropdown')) {
					$(this).after(
						'<div class="dropdown ' +
						($(this).attr('class') || '') +
						'" tabindex="0"> ' +
						' <span class="current"></span>   ' +
						' <div class="qtyBlock"> <span class="qty_label">Qty:</span> <span class="current"></span>' +
						' <div class="list">   <ul></ul>  </div>   </div> </div>'
					);
					var dropdown = $(this).next();
					var options = $(select).find('option');
					var selected = $(this).find('option:selected');
					dropdown
						.find('.current')
						.html(selected.data('display-text') || selected.text());
					options.each(function (j, o) {
						var display = $(o).data('display-text') || '';
						dropdown
							.find('ul')
							.append(
								'<li class="option ' +
								($(o).is(':selected') ? 'selected' : '') +
								'" data-value="' +
								$(o).val() +
								'" data-display-text="' +
								display +
								'">' +
								$(o).text() +
								'</li>'
							);
					});
				}
			});

			// Event listeners
			$('body').on('click', '.dropdown', function () {
				$('.dropdown').not($(this)).removeClass('open');
				$(this).toggleClass('open');
				if ($(this).hasClass('open')) {
					$(this).find('.option').attr('tabindex', 0);
					$(this).find('.selected').focus();
				} else {
					$(this).find('.option').removeAttr('tabindex');
					$(this).focus();
				}
			});

			$('body').on('click', function (event) {
				if ($(event.target).closest('.dropdown').length === 0) {
					$('.dropdown').removeClass('open');
					$('.dropdown .option').removeAttr('tabindex');
				}
			});

			$('body').on('click', '.dropdown .option', function () {
				$(this)
					.closest('.list')
					.find('.selected')
					.removeClass('selected');
				$(this).addClass('selected');
				var text = $(this).data('display-text') || $(this).text();
				$(this).closest('.dropdown').find('.current').text(text);
				$(this)
					.closest('.dropdown')
					.prev('select')
					.val($(this).data('value'))
					.trigger('change');
			});
		}
	},
	AddtoCart_slot() {
		$('body').on('click', '.add-to-cart-Addon', function () {
			var addToCartUrl;
			var pid;
			pid = $(this).attr('data-id');
			addToCartUrl = $(this).attr('data-url');
			var productName = $(this).attr('gtm-data-product');
			var masterId = $(this).attr('data-gtm-masterid');
			var price = $(this).attr('gtm-data-price');
			var gtmCategory = $(this).attr('data-gtm-category');
			var gtmYMALProductData = {
				name: productName,
				id: masterId,
				brand: 'James Avery',
				price: Number(parseFloat(price.replace('$', '')).toFixed(2)),
				category: gtmCategory,
				variant: pid,
				quantity: 1,
				list: gtmCategory
			};
			var analyticsAddToCartData = [];
			analyticsAddToCartData.push(gtmYMALProductData);
			var form = {
				pid: pid,
				quantity: 1
			};
			form.analyticsAddToCartData = getAnalyticsProductListData(analyticsAddToCartData,false);
			form.csrf_token = $.trim($('input[name=csrf_token]').val());
			if (addToCartUrl) {
				$('body').trigger('cart:ymlupdate', gtmYMALProductData);
				$.ajax({
					url: addToCartUrl,
					method: 'POST',
					data: form,
					success: function () {
						$.spinner().stop();
						location.reload();
					},
					error: function () {
						$.spinner().stop();
					},
				});
			}
		});
	},upsellCarouselInit : function(){
		var carousel = require('../components/carousel');
		$('body').on('cart:update',function(e,data){ 
			if(data.upsellCarouselHtml){
				$('.upsell-carousel').empty().html(data.upsellCarouselHtml);
				carousel.renderUpSellCarousel();
			}
		});
		$('body').on('click', '.add-to-cart-upsell', function () {
			var addToCartUrl;
			var pid;
			
			pid = $(this).attr('data-id');
			addToCartUrl = $(this).attr('data-url');
			var gtmUpsellProductData = $(this).parents('.product').attr('data-upsell-gtm');
			if(gtmUpsellProductData){
				gtmUpsellProductData = JSON.parse(gtmUpsellProductData);
				gtmUpsellProductData.list = 'Customers Also Bought';
			}
			var analyticsAddToCartData = [];
			analyticsAddToCartData.push(gtmUpsellProductData);
			var form = {
				pid: pid,
				quantity: 1
			};
			form.analyticsAddToCartData = getAnalyticsProductListData(analyticsAddToCartData,false);
			form.csrf_token = $.trim($('input[name=csrf_token]').val());
			if (addToCartUrl) {
				$.spinner().start();
				$('body').trigger('cart:upsellupdate', gtmUpsellProductData);
				$.ajax({
					url: addToCartUrl,
					method: 'POST',
					data: form,
					success: function () {
						$.spinner().stop();
						location.reload();
					},
					error: function () {
						$.spinner().stop();
					},
				});
			}
		});
	},
	updateShippingMethod: function () {
		var shippingMethod, shippingMethodUrl;
		$('input[type=radio][name=delivery-method]').change(function (e) {
			e.preventDefault();
			shippingMethod = $('input[name=delivery-method]:checked').val();
			shippingMethodUrl = $(this).attr('data-url');
			$('body').trigger('cart:shipmentUpadte', shippingMethod);
			$.ajax({
				url: shippingMethodUrl,
				method: 'POST',
				data: { 
					shipmentSelected: shippingMethod,
					csrf_token: $.trim($('.cart.container input[name=csrf_token]').val())
				},
				success: function (data) {
					if (data) {
						location.reload();
					}
				},
			});
		});
	},
	handleInventoryMsgOnCheckout: function () {
		$('.checkout-continue')
			.find('.checkout-btn')
			.on('click', function (event) {
				if ($(this).attr('data-out-of-stock') == 'true') {
					showHideInventoryMessage(
						event,
						$(this).attr('data-out-of-stock-msg'),
						false
					);
				}
				if ($(this).attr('data-store-selected') == 'true') {
					showHideInventoryMessage(
						event,
						$(this).attr('data-store-selected-msg'),
						false
					);
				}
			});
	},
	updateProratedMessage: function () {
		$('body').on('cart:updateProratedMessage', function (e,data) {
			if ($('.prorated-msg-wrapper').length && (data.isProratedPromoApplied || data.proratedMissedMessage)) {
				$('.prorated-msg-incart').removeClass('d-none');
				$('.prorated-msg-wrapper').addClass('d-none');
				if (data.isProratedPromoApplied) {
					$('.prorated-msg-wrapper.applied').removeClass('d-none');
					$('body').trigger('charmPromo:progress','100%');
				} else if(data.proratedMissedMessage) {
					if(data.proratedMissedMessage.charmQuantity == 1 && data.proratedMissedMessage.holderQuantity == 0){
						$('.prorated-msg-wrapper.secondary-charm').removeClass('d-none');
						$('body').trigger('charmPromo:progress','33%');
					} else if(data.proratedMissedMessage.charmQuantity == 0 && data.proratedMissedMessage.holderQuantity >= 1){
						$('.prorated-msg-wrapper.primary-charm').removeClass('d-none');
						$('body').trigger('charmPromo:progress','33%');
					} else if(data.proratedMissedMessage.charmQuantity == 1 && data.proratedMissedMessage.holderQuantity >= 1){
						$('.prorated-msg-wrapper.secondary-charm-two').removeClass('d-none');
						$('body').trigger('charmPromo:progress','66%');
					} else if(data.proratedMissedMessage.charmQuantity > 1) {
						$('.prorated-msg-wrapper.secondary-holder').removeClass('d-none');
						$('body').trigger('charmPromo:progress','66%');
					} else {
						$('.prorated-msg-incart').addClass('d-none');
					}
				}
			} else {
				$('.prorated-msg-incart').addClass('d-none');
			}
		});
	},
	handleStoreChange: function () {
		$('#storeModalDialog').on('hidden.bs.modal', function () {
			var getModalCloseBtn = $(
				'.cart-page #storeModalDialog .modal-header'
			).find('.close');
			if (getModalCloseBtn.attr('data-store-change') == 'true') {
				location.reload();
			}
		});
	},
	cartStoreSelection: function () {
		$('body').on('click', '.find-a-store', function () {
			$.spinner().start();
			var urlNew = $('.findStoreNew').val();
			var thisVar = $(this);
			var storeModalHtml;
			var storeLocatorContainer = $('.store-locator-container');
			if (storeLocatorContainer && storeLocatorContainer.length > 0) {
				storeLocatorModal.getStoreModal(thisVar);
			} else {
				$.ajax({
					url: urlNew,
					method: 'GET',
					success: function (result) {
						storeModalHtml = result;
						$('#storeModalDialog .modal-body').html(storeModalHtml);
						storeLocatorModal.getStoreModal(thisVar);
					}
				});
			}
		});
	},
	checkoutXsstore: function () {
		$('#checkout-xstore').on(
			'click',
			'.checkout-btn.xstore-pos',
			function (e) {
				e.preventDefault();
				$.ajax({
					url: $('#xstore-pos-clear-url').val(),
					method: 'POST',
					dataType: 'jsonp',
					success: function () { },
					error: function () { },
				});
				$(document).trigger('xstorePos:clearPosSession');
			}
		);

		$(document).on('xstorePos:clearPosSession', function () {
			var clearUrl = $('#xs-store-URL').val();
			if (clearUrl) {
				window.location = clearUrl;
			}
		});
	},

	viewPayLoad: function () {
		$('#viewCartPayload').on('click', function () {
			$('#posViewPayloadContentSlot').text(
				JSON.stringify(
					JSON.parse($('#posViewPayloadContent').text()),
					undefined,
					4
				)
			);
		});
	},
});

module.exports = exportCart;
